import styled from "styled-components";

export const ReverseRowComponent = styled.div`
	display: flex;
	flex-direction: row-reverse;
	justify-content: space-between;
`;
